<div  *ngFor="let detailReportCategory of detailReportCategories">
<div class="row category-header m-t-30">
    <div class="col-7">{{ detailReportCategory.name }}</div>
    <div class="col-1 m-l-15">{{ detailReportCategory.averageValue }}</div>
</div>
    <div class="col-8" style="padding:0; margin:0;">
        <hr />
    </div>
<app-category-question [detailReportQuestion]="detailReportQuestion" *ngFor="let detailReportQuestion of detailReportCategory.questions">
</app-category-question>
</div>
